<ng-container *inPopulation="[populations.JuniorBluebirds]">
  <fgb-banner
    [isImageBanner]="true"
    [imageBannerUrl]="'banners/kids-activities-banner.jpg'"
    class="d-lg-flex d-none"
  ></fgb-banner>
  <div class="d-block d-lg-none">
    <fgb-mobile-page-header
      pageTitle="activities.page.banner.title"
      [showFooter]="true"
      [showQr]="false"
      [showBalance]="false"
      [backButtonLink]="'/'"
      [isImageBanner]="true"
      [imageBannerUrl]="'banners/kids-activities-banner.jpg'"
    ></fgb-mobile-page-header>
  </div>
</ng-container>
<div class="mt-lg-2 worksheet-page-list">
  <fgb-worksheet-list [hasWorksheetTitle]="false"></fgb-worksheet-list>
</div>
